import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ConceptService } from 'app/infrastructure/services/catalog/concept.service';
import { PlantasService } from 'app/infrastructure/services/catalog/plantas.service';
import Swal from 'sweetalert2';
import { PriceValidService } from 'app/infrastructure/services/alpura/price-valid.service';
import { LotesService } from '@infrastructure/services/alpura/lotes.service';
import { getISOWeek } from 'date-fns';
import { environment } from 'environments/environment';
import { Socio } from '@domain/models/socio.model';
import { PermissionsService } from '@application/services/permissions.service';
import { ContractShareService } from '@infrastructure/services/alpura/cat-share.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-captura-incidencias-lote',
  templateUrl: './captura-incidencias-lote.component.html',
  styleUrls: ['./captura-incidencias-lote.component.scss'],
  providers: [
    ConceptService,
    LotesService,
    PriceValidService,
    ContractShareService,
    PlantasService
  ]
})

export class CapturaIncidenciasLoteComponent implements OnInit {
  listaTipo: any[] = [
    { "id": 1, "nombre": "Variable" },
    { "id": 0, "nombre": "Fijo" }
  ]
  listaPlantas: any[] = [];
  listaConceptos: any[] = [];
  datosTabla: any[] = new Array(50).fill({ proveedor: '', importe: '', comentario: '' });
  disableForm: boolean = false;
  fieldsDisabled: boolean = false;
  isNuevoClicked: boolean = false;
  selectedPlanta: any;
  selectedTipo: any;
  selectedConcepto: any;
  selectedSemana: any;
  loteRequestData: any[] = [];
  listaPartnerOriginal: Socio[] = [];
  listaPartner: Socio[] = [];
  socioSelect: any = "";
  decimales: string = "";
  esPunto: boolean = false;
  public opcionesLimpia : any = 1;
  guardarFG: UntypedFormGroup = this.untypedFormBuilder.group({
    idNumIdIncidencia: ['', [Validators.required]],
    idNumFacilityId: ['', [Validators.required]],
    idCmbTipo: ['', [Validators.required]],
    idNumSemana: ['', [Validators.required]],
    idCmbConceptoid: ['', [Validators.required]],
    socioSeleccionado: ['', [Validators.required]]
  });
  

  semana: number = 0;

  validateWeekInput(event: KeyboardEvent, maxCharacters: number) {
    const inputChar = String.fromCharCode(event.keyCode);
    const numericRegex = /^[0-9]$/;
    const target = event.target as HTMLInputElement;
    const newValue = (target.value || '').replace(/[^\d]/g, '').slice(0, maxCharacters);
    target.value = newValue;
    if (!numericRegex.test(inputChar) || (target.value && target.value.length >= maxCharacters)) {
      event.preventDefault();
    }
  }

  permisos: any;

  constructor(
    private plantasService: PlantasService,
    private conceptService: ConceptService,
    private _precio: PriceValidService,
    private cdr: ChangeDetectorRef,
    private untypedFormBuilder: UntypedFormBuilder,
    private _contract: ContractShareService,
    private http: HttpClient,
    private permissionsService: PermissionsService,
  ) {
    this.permisos = {
      edicion: this.permissionsService.hasPermission("INCIDENCIA_LOTES-EDITAR"),
    }

    this.guardarFG.get('idNumFacilityId')?.valueChanges.subscribe(val => {
      this.actualizarRegistrosSocios(val);
    })
  }

  ngOnInit(): void {
    this.obtenerPlantas();
    this.obtenerConceptos();
    this.obtenerDatosSemana();
    this.agregarFilaInicial();
    this._precio.obtenerDatosSocios().subscribe(async (res: any) => {
      this.listaPartnerOriginal = res.filter((x: { status: number; }) => x.status == 1);
      this.actualizarRegistrosSocios(0);
    });
  }

  actualizarRegistrosSocios(planta:number){
    this.listaPartner = this.listaPartnerOriginal.filter((x: { idFacility: number; }) => x.idFacility == planta);
  }

  agregarFilaInicial() {

    for (let i = 0; i < 50; i++) {
      this.datosTabla.push({ proveedor: '', importe: '', comentario: '' });
    }
  }

  obtenerPlantas() {
    this.plantasService.findAllPlantas().subscribe((s: any) => {
      this.listaPlantas = s;
    });
  }

  obtenerConceptos() {
    this.conceptService.findAllConc().subscribe((s: any) => {
      this.listaConceptos = s.filter((f: any) => f.incidencias === 'TRUE' && f.costo == "FALSE");
    });
  }



  validateProveedorInput(event: KeyboardEvent, maxCharacters: number) {
    const inputChar = String.fromCharCode(event.keyCode);
    const numericRegex = /^[0-9]$/;
    const target = event.target as HTMLElement;
    const newValue = (target.textContent || '').replace(/[^\d]/g, '').slice(0, maxCharacters);
    target.textContent = newValue;

    if (!numericRegex.test(inputChar) || (target.textContent && target.textContent.length >= maxCharacters)) {
      event.preventDefault();
    }
  }
  validateImporteInput(event: KeyboardEvent, maxCharacters: number) {
    const inputChar = String.fromCharCode(event.keyCode);
    const numericRegex = /^[0-9]$/;
    const target = event.target as HTMLElement;
    const newValue = (target.textContent || '').replace(/[^\d]/g, '').slice(0, maxCharacters);
    target.textContent = newValue;
    if (!numericRegex.test(inputChar) || (target.textContent && target.textContent.length >= maxCharacters)) {
      event.preventDefault();
    }
  }
  keyUpMeto (event: any, i: number){
    let key = event.key
      const regex = /[.]|\./;
      if (regex.test(key)){
        this.esPunto = true;
      }
      if (this.esPunto && key == "Backspace"){
        this.decimales.slice(1);
      }
      let condicion = this.esPunto && this.decimales.length <= 3 && key != "Backspace";
      this.decimales = condicion ? this.decimales + key: this.decimales
      

  }
  
  validateFormat(event: any) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9,.]|\./;
    if (!regex.test(key) ) {
      event.returnValue = false;
      Swal.fire({
        icon: 'info',
        title: 'Solo se permite ingreso de Números',
        showConfirmButton: false,
        timer: 1000,
      });
      if (event.preventDefault) {
        event.preventDefault();
      }
      
    } 
    if (this.decimales.length >= 3){
      Swal.fire({
        icon: 'info',
        title: 'Solo se permite ingreso de 2 decimales',
        showConfirmButton: true
      });
      event.returnValue = false;
    }
  }

  onBlurSocio(event: any, index: number){
    this.datosTabla = this.datosTabla.map((dato, i) =>
      i === index ? { ...dato, proveedor: event } : dato
    );
    this.cdr.detectChanges();
  }

  onImporteChange(event: any, index: number) {
    const target = event.target as HTMLElement;
    const inputValue = event.target.textContent?.trim() || '';
    const formattedValue = this.formatImporte(inputValue);
    target.textContent = formattedValue == "NaN"? "": formattedValue;
    let newImporte = event.target.textContent?.trim() || '';
    this.datosTabla = this.datosTabla.map((dato, i) =>
      i === index ? { ...dato, importe: newImporte } : dato
    );
    this.cdr.detectChanges();
    this.decimales = "";
    this.esPunto = false;
  }
  onComentarioChange(event: any, index: number) {
    let newComentario = event.target.textContent?.trim() || '';
    this.datosTabla = this.datosTabla.map((dato, i) =>
      i === index ? { ...dato, comentario: newComentario } : dato
    );
    this.cdr.detectChanges();
  }


  formatImporte(inputValue: string) {
    const numericRegex = /^[0-9,.]*$/;
    if (!numericRegex.test(inputValue)) {
      return '';
    }
    const formattedValue = inputValue.replace(/[^\d,.]/g, '');
    const truncatedValue = formattedValue.slice(0, 15);
    const valueAsNumber = parseFloat(truncatedValue.replace(/,/g, ''));
    return valueAsNumber.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  showNuevo() {
    this.limpiarFormulario();
    this.datosTabla = Array(50).fill({ proveedor: '', importe: '', comentario: '' });
    this.cdr.detectChanges();
    this.opcionesLimpia = 2;
  }

  limpiarFormulario() {
    let idNumSemanaControl = this.guardarFG.get('idNumSemana');
     /**
     * Guardar el valor de idNumSemana antes de limpiar
     * hola mundo :)
     */
    const idNumSemanaValue = idNumSemanaControl ? idNumSemanaControl.value : null;
    this.guardarFG.reset();
    if (idNumSemanaControl && idNumSemanaValue !== null) {
      idNumSemanaControl.setValue(idNumSemanaValue);
  }
    this.datosTabla = Array(50).fill({ proveedor: '', importe: '', comentario: '' });
    let cells = document.querySelectorAll('[contenteditable="true"]');
    cells.forEach((cell) => {
      (cell as HTMLElement).innerText = '';
    });
    this.listaPartner = this.listaPartner
    this.cdr.detectChanges();
    this.disableForm = false;
    this.fieldsDisabled = false;
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  async showGuardar() {
    if (this.datosTabla.length === 0) {
      return;
    }

    const datosLlenos = this.datosTabla.filter(dato => dato.proveedor.trim() !== '');

    if (datosLlenos.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Datos incompletos',
        text: 'Por favor, ingresa al menos un proveedor en la tabla antes de guardar.'
      });
      return;
    }
    let facilityControl = this.guardarFG.get('idNumFacilityId');
    let tipoControl = this.guardarFG.get('idCmbTipo');
    let semanaControl = this.guardarFG.get('idNumSemana');
    let conceptoControl = this.guardarFG.get('idCmbConceptoid');
    let currentYear = new Date().getFullYear();
    let payload: any = {
      "facility": facilityControl ? facilityControl.value : null,
      "tipo": tipoControl ? tipoControl.value : null,
      "semana": semanaControl ? semanaControl.value : null,
      "concepto": conceptoControl ? conceptoControl.value : null,

      ejercicio: currentYear,
      folio: this.guardarFG.get('idNumIdIncidencia')?.value,
      estado: "A",
      loteRequest: datosLlenos.map(dato => ({
        numeroProveedor: parseInt(dato.proveedor.trim(), 10),
        importe: dato.importe.replace(/,/,''),
        comentario: dato.comentario.trim()
      }))
    };

    if (!(await this.validarCierre(payload.semana, payload.ejercicio))) return;

    const url = environment.insertIncidenciasLote;
    this.http.post(url, payload).subscribe(
      (response: any) => {

        if (response.isSuccess){
          this.limpiarFormulario();
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: 'Datos guardados correctamente'
          });
        }
        else {
          this.limpiarFormulario();
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Error al guardar los datos'
          });
        }
      },
      (error: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron guardar los datos'
        });
      }
    );
  }

  obtenerDatosSemana(): void {
    const fechaActual = new Date();
    this.semana = this.obtenerNumeroSemana(fechaActual);
    this.guardarFG.patchValue({
      idNumSemana: this.semana
    });
  }

  obtenerNumeroSemana(fecha: Date): number {
    return getISOWeek(fecha);
  }

  async validarCierre(week: number, year: number) {
    var dataSem = {
      partnerId: 4053,
      year: year,
      week: week,
    };
    try {
      const data$ = this._contract.getInfoCierreSemanal(dataSem);
      const data: any = await lastValueFrom(data$);
      if (data.validacion == 'C') {
        Swal.fire({
          icon: 'error',
          title: '¡Error!',
          html: `No se puede actualizar<br>Semana cerrada`,
        });
        return false;
      }
      return true;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '¡Error!',
        html: `No se puede actualizar<br>Error del servicio`,
      });
      return false;
    }
  }

}